import { useEffect, useState, RefObject } from 'react';

// ahooks have bug that ref change to null but still return true
function useInViewport<T extends HTMLElement>(ref: RefObject<T>): [boolean] {
  const [inViewport, setInViewport] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      setInViewport(false);
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setInViewport(entry.isIntersecting);
    });

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, [ref.current]);

  return [inViewport];
}

export default useInViewport;
